import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import { MARIGOLD_MEDIUM } from 'HubStyleTokens/colors';
import H4 from 'UIComponents/elements/headings/H4';
import UIBreakString from 'UIComponents/text/UIBreakString';
import ReviewSection from './ReviewSection';
import * as ReviewQuestions from '../constants/ReviewQuestions';
import { MINIMUM_SEARCH_LENGTH } from '../constants/ReviewsListQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ReviewBody({
  review,
  className,
  searchTerm,
  catalogServices,
  reviewType,
  showOriginal
}) {
  const answers = showOriginal ? Object.fromEntries(review.get('original').answers) : Object.fromEntries(review.get('answers'));
  const tags = showOriginal ? Object.fromEntries(review.get('original').tags) : Object.fromEntries(review.get('tags'));
  const customizableKey = reviewType === 'THEME' ? 'customizable_theme' : 'customizable_module';
  const renderAnswer = question => {
    const answer = answers[question];
    let renderedAnswer = answer;
    if (!answer) {
      return null;
    }
    const textKey = `marketplace-ui-reviews.responses.${question === 'CUSTOMIZABLE' ? customizableKey : question}`;
    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });
    if (searchTerm && searchTerm.length >= MINIMUM_SEARCH_LENGTH) {
      const regex = new RegExp(`((?=${searchTerm})|(?<=${searchTerm}))`, 'i');
      const splitText = answer.split(regex);
      renderedAnswer = splitText.map((text, index) => {
        return text.toLowerCase() === searchTerm.toLowerCase() ? /*#__PURE__*/_jsx("span", {
          style: {
            backgroundColor: MARIGOLD_MEDIUM
          },
          children: text
        }, index) : /*#__PURE__*/_jsx("span", {
          children: text
        }, index);
      });
    }
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: question === 'TITLE' ? /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: renderedAnswer
        })
      }) : /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: renderedAnswer
        })
      })
    }, question);
  };
  const renderTags = tagField => {
    const tagList = tags[tagField];
    if (!tagList || !tagList.length) {
      return null;
    }
    const textKey = `marketplace-ui-reviews.responses.${tagField}`;
    const title = isValidI18nKey(textKey) && /*#__PURE__*/_jsx(FormattedMessage, {
      message: textKey
    });
    if (tagField === 'CATALOG_SERVICES' && catalogServices) {
      return /*#__PURE__*/_jsx(ReviewSection, {
        title: title,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(UIBreakString, {
            children: /*#__PURE__*/_jsx(FormattedList, {
              children: tagList.map(service => {
                const selectedService = catalogServices.filter(catService => catService.id === service)[0];
                return selectedService && selectedService.name || '';
              })
            })
          })
        })
      }, tagField);
    }
    return /*#__PURE__*/_jsx(ReviewSection, {
      title: title,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: /*#__PURE__*/_jsx(FormattedList, {
            children: tagList.map(tag => tag)
          })
        })
      })
    }, tagField);
  };
  if (!review.hasContent()) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [ReviewQuestions.QuestionOrder.map(question => renderAnswer(question)), ReviewQuestions.TagOrder.map(tagField => renderTags(tagField))]
  });
}